import { HttpParams } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { BaseCrudService } from "app/shared/_utils/services/base-crud-service";
import { QueryOperator } from "app/shared/_utils/services/query-operator.enum";
import { ResponsePageable } from "app/shared/_utils/services/responsePageable";
import { LazyLoadEvent } from "primeng/api";
import { Observable } from "rxjs/Observable";
import { tap } from "rxjs/operators";
import { PettyCashSummary } from "../entities/petty-cash-summary";


@Injectable()
export class PettyCashSummaryService extends BaseCrudService<PettyCashSummary> {

  public uri = '/api/pettyCashSummary/';

  constructor(injector: Injector) {
    super(injector);
    // console.log('Instance PettyCashSummaryService');
  }

  buildSentence(entity?: PettyCashSummary, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.pettyCashMaster && entity.pettyCashMaster.id) {
        query = query.concat(
          `pettyCashMaster.id${QueryOperator.Equal}${entity.pettyCashMaster.id}${QueryOperator.Split}`
        );
      }
      if (entity.voucherMain && entity.voucherMain.id) {
        query = query.concat(
          `voucherMain.id${QueryOperator.Equal}${entity.voucherMain.id}${QueryOperator.Split}`
        );
      }
      if (entity.status && entity.status.code) {
        query = query.concat(
          `status.code${QueryOperator.Equal}${entity.status.code}${QueryOperator.Split}`
        );
      }

      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    // this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'startContractDate');

    return this.httpParams;
  }


  // logicDelete(key: string | number): Observable<any> {
  //   const url = this.rutaServidor + this.uri + 'logicDelete/' + key;
  //   return this.httpClient.get(url);
  // }

  searchGenerate(key: string | number): Observable<PettyCashSummary[]> {
    const url = this.rutaServidor + this.uri + 'search/' + key;
    this.spinnerService.showAll();
    return this.httpClient.get<PettyCashSummary[]>(url)
      .pipe(
        tap(response => {
          if (response.length > 0) {
            response.forEach((value) => {
              // debugger;
              this.addLogicToSearch(value);
              this.convertToDate(value);
            })
          }
          //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }


  // searchGenerate(entity?: PettyCashSummary, event?: LazyLoadEvent, extraQueryCondition?: string): Observable<ResponsePageable<PettyCashSummary>> {

  //   const url = this.rutaServidor + this.uri + 'search';
  //   this.spinnerService.showAll();
  //   return this.httpClient.get<ResponsePageable<PettyCashSummary>>(url, { params: this.buildSentence(entity, event) })
  //     .pipe(
  //       tap(response => {
  //         if (response.numberOfElements > 0) {
  //           response.content.forEach((value) => {
  //             // debugger;
  //             this.addLogicToSearch(value);
  //             this.convertToDate(value);
  //           })
  //         }
  //         //console.log(response);
  //         this.spinnerService.hideAll();
  //         return response;
  //       })
  //     );
  // }

}



// WEBPACK FOOTER //
// ./src/app/core/services/petty-cash-summary.service.ts